export type BillingsOrderRailyTaxiCreateParamsBillingNode = {
  uuid: string;
  nodeUuid: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate?: Date;
  checkoutEventUuid?: string;
  plannedDate?: Date;
  orderUuid?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export enum BillingsOrderRailyTaxiCreateParamsPenaltyType {
  OPTIMIZATION_REFUSED = "OPTIMIZATION_REFUSED",
  BEING_LATE = "BEING_LATE",
  INCOMPATIBLE_CAR = "INCOMPATIBLE_CAR",
  HIGHWAY_NOT_ALLOWED = "HIGHWAY_NOT_ALLOWED",
  SUBOPTIMAL_RIDE = "SUBOPTIMAL_RIDE",
  GUIDELINE_IGNORED = "GUIDELINE_IGNORED",
  OTHER = "OTHER",
}

export enum BillingsOrderRailyTaxiCreateParamsBonusType {
  DISTANCE_RATE_CHANGED = "DISTANCE_RATE_CHANGED",
  HALTING_RATE_CHANGED = "HALTING_RATE_CHANGED",
  SHORT_ROUTE = "SHORT_ROUTE",
  OTHER = "OTHER",
}

type BillingsOrderRailyTaxiCreateParams = {
  orderUuid: string;
  billingNodes: BillingsOrderRailyTaxiCreateParamsBillingNode[];
  bonus: number;
  penalty: number;
  penaltyType?: BillingsOrderRailyTaxiCreateParamsPenaltyType;
  bonusType?: BillingsOrderRailyTaxiCreateParamsBonusType;
};

export default BillingsOrderRailyTaxiCreateParams;
